import styled from 'styled-components';
import { DropDown, breakpoint } from '@grays-npm/component-library';
import { Carousel } from '../Carousel';
import { CarouselDataItem } from '../Carousel/CarouselCard';
import { statisticsOptions, StatsDurations } from './StatisticsOptions';

const Wrapper = styled.div`
  width: 100%;

  ${breakpoint('lg')`
    margin: 0 0 ${({ theme }) => theme.spacings[6].rem};
  `}
`;

const StyledDropDown = styled(DropDown)`
  margin: ${({ theme }) => theme.spacings[4].rem} 0;
  display: flex;
  white-space: nowrap;

  ${breakpoint('lg')`
    margin: ${({ theme }) => theme.spacings[5].rem} 0;
  `}
`;

export type StatisticsProps = {
  statistics: CarouselDataItem[];
  duration: StatsDurations;
  onChange: (option: string) => void;
};

export const Statistics: React.FC<StatisticsProps> = ({
  statistics,
  duration,
  onChange,
}) => (
  <Wrapper>
    <StyledDropDown
      label="Stats overview for"
      onChange={onChange}
      options={statisticsOptions}
      selectedValue={duration}
    />
    <Carousel data={statistics} />
  </Wrapper>
);
